var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyProperties(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 106,
    viewBox: "0 0 202 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.39 4.41406C198.062 4.41406 201.85 8.20208 201.85 12.8749C201.85 17.5476 198.062 21.3357 193.39 21.3357H145.042C149.715 21.3357 153.503 25.1237 153.503 29.7964C153.503 34.4692 149.715 38.2572 145.042 38.2572H171.633C176.306 38.2572 180.094 42.0453 180.094 46.718C180.094 51.3908 176.306 55.1788 171.633 55.1788H159.336C153.444 55.1788 148.668 58.9668 148.668 63.6396C148.668 66.755 151.086 69.5749 155.92 72.1004C160.593 72.1004 164.381 75.8884 164.381 80.5612C164.381 85.234 160.593 89.022 155.92 89.022H55.5995C50.9267 89.022 47.1387 85.234 47.1387 80.5612C47.1387 75.8884 50.9267 72.1004 55.5995 72.1004H8.46079C3.78802 72.1004 0 68.3124 0 63.6396C0 58.9668 3.78802 55.1788 8.46079 55.1788H56.8082C61.481 55.1788 65.269 51.3908 65.269 46.718C65.269 42.0453 61.481 38.2572 56.8082 38.2572H26.5911C21.9183 38.2572 18.1303 34.4692 18.1303 29.7964C18.1303 25.1237 21.9183 21.3357 26.5911 21.3357H74.9385C70.2657 21.3357 66.4777 17.5476 66.4777 12.8749C66.4777 8.20208 70.2657 4.41406 74.9385 4.41406H193.39ZM193.39 38.2572C198.062 38.2572 201.85 42.0453 201.85 46.718C201.85 51.3908 198.062 55.1788 193.39 55.1788C188.717 55.1788 184.929 51.3908 184.929 46.718C184.929 42.0453 188.717 38.2572 193.39 38.2572Z",
    fill: "#F3F3F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8347 82.9819C111.197 82.9819 129.326 64.8534 129.326 42.4909C129.326 20.1285 111.197 2 88.8347 2C66.4722 2 48.3438 20.1285 48.3438 42.4909C48.3438 64.8534 66.4722 82.9819 88.8347 82.9819Z",
    fill: "#F3F7FF",
    stroke: "#979797",
    strokeWidth: 3.02171
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.3466 73.9096C84.4727 74.3019 86.635 74.5055 88.8348 74.5212C106.525 74.5212 120.865 60.1808 120.865 42.4911C120.865 24.8014 106.525 10.4609 88.8348 10.4609C84.2908 10.4609 79.9673 11.4073 76.0518 13.1134C69.2469 16.0789 63.6718 21.3391 60.305 27.9168C58.0672 32.2886 56.8047 37.2424 56.8047 42.4911C56.8047 47.2533 57.8441 51.7726 59.7079 55.835C61.0387 58.7352 62.7901 61.4028 64.8841 63.7585",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3466 73.9096C84.4727 74.3019 86.635 74.5055 88.8348 74.5212C106.525 74.5212 120.865 60.1808 120.865 42.4911C120.865 24.8014 106.525 10.4609 88.8348 10.4609C84.2908 10.4609 79.9673 11.4073 76.0518 13.1134C69.2469 16.0789 63.6718 21.3391 60.305 27.9168C58.0672 32.2886 56.8047 37.2424 56.8047 42.4911C56.8047 47.2533 57.8441 51.7726 59.7079 55.835C61.0387 58.7352 62.7901 61.4028 64.8841 63.7585",
    stroke: "#979797",
    strokeWidth: 3.02171,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6484 67.3594C71.2447 69.4697 74.1782 71.1819 77.3552 72.402",
    stroke: "#979797",
    strokeWidth: 3.02171,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M122.078 74.5234L129.33 81.7755",
    stroke: "#979797",
    strokeWidth: 3.02171
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.154 80.5988C125.865 82.8863 125.865 86.5951 128.154 88.8832L141.552 102.281C143.84 104.569 147.549 104.569 149.837 102.281C152.124 99.994 152.124 96.2851 149.837 93.9971L136.438 80.5988C134.15 78.3108 130.441 78.3108 128.154 80.5988Z",
    fill: "#E8F0FE",
    stroke: "#979797",
    strokeWidth: 3.02171
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M134.164 82.9844L147.46 96.2799",
    stroke: "white",
    strokeWidth: 3.02171,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.9861 28.5953C80.9861 42.6137 92.3501 53.9777 106.368 53.9777C109.122 53.9777 111.774 53.539 114.256 52.7279C110.204 62.7854 100.352 69.8846 88.8425 69.8846C73.7158 69.8846 61.4531 57.6219 61.4531 42.4952C61.4531 28.7881 71.5215 17.4331 84.6665 15.4219C82.3313 19.2637 80.9861 23.7721 80.9861 28.5953Z",
    fill: "#DCBCFA",
    fillOpacity: 0.13
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4416 20.1328C87.9023 20.1328 86.3987 20.2845 84.9447 20.5728M80.5511 21.9168C72.2831 25.3918 66.4766 33.5667 66.4766 43.0978",
    stroke: "#505050",
    strokeOpacity: 0.29,
    strokeWidth: 3.02171,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M153.718 42.8302H143.836M161.362 33.4297H140.602M169.823 33.4297H167.138",
    stroke: "#505050",
    strokeOpacity: 0.29,
    strokeWidth: 3.02171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9284 69.4139H35.0462M39.2766 58.8047H18.5162M11.4769 58.8047H6.375",
    stroke: "#505050",
    strokeOpacity: 0.29,
    strokeWidth: 3.02171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyProperties);
export default __webpack_public_path__ + "static/media/empty-properties.0bbb0b3736de74b7786b1f4d99a1703a.svg";
export { ForwardRef as ReactComponent };